import request from '@/utils/request'

export const OtomatikTamamlama = (alan, q) => {
    return request({
        url:'OtomatikTamamlama/',
        params: {
            alan,
            q
        }
    })
};
